import * as React from "react";
const SvgReceipt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g
      stroke="#89909D"
      strokeLinecap="round"
      strokeLinejoin="round"
      clipPath="url(#receipt_svg__a)"
    >
      <path
        strokeWidth={1.25}
        d="M9.301 12.647h2.7m-2.7-3.6h2.7M21 6.337v2.179c0 1.422-.9 2.322-2.322 2.322H15.6V4.547c0-1 .819-1.81 1.818-1.81a3.62 3.62 0 0 1 2.529 1.054A3.62 3.62 0 0 1 21 6.338M3 19.838a.897.897 0 0 0 1.44.72l1.539-1.151a.91.91 0 0 1 1.188.09l1.494 1.503a.907.907 0 0 0 1.278 0l1.512-1.512a.89.89 0 0 1 1.17-.081l1.539 1.152c.594.44 1.44.018 1.44-.72v-15.3c0-.99.81-1.8 1.8-1.8h-10.8c-2.7 0-3.6 1.61-3.6 3.6z"
      />
      <path strokeWidth={1.4} d="M6.598 12.638h.008M6.598 9.038h.008" />
    </g>
    <defs>
      <clipPath id="receipt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgReceipt;
